module.exports = __webpack_public_path__ + "img/appstore_image.2d068ea6.png";